/**
 * Publishes the live Tiptap Editor instance so components outside Editor.tsx's
 * subtree (MenuBar) can reach it with React reactivity. editorRef.ts already
 * does this for the raw ProseMirror EditorView (for the non-React host bridge)
 * — this is the same pattern, but via Zustand so React re-renders on mount/unmount.
 */

import { create } from "zustand";
import type { Editor } from "@tiptap/react";

interface EditorStore {
  editor: Editor | null;
  setActiveEditor: (editor: Editor) => void;
  clearActiveEditor: (editor: Editor) => void;
}

export const useEditorStore = create<EditorStore>((set, get) => ({
  editor: null,
  setActiveEditor: (editor: Editor) => set({ editor }),
  clearActiveEditor: (editor: Editor) => {
    if (get().editor === editor) set({ editor: null });
  },
}));
